import { call, put } from 'redux-saga/effects'
import { RequestMethods } from 'utils/axios/methods'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Actions_Notifications } from 'redux/modules/notification/Actions'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'
import { SagaWorker_GetUserNotes } from 'redux/sagas'
import { TCreateNotePayload } from 'redux/modules/parkingNotes/TReducer'
import { Actions_UserNotes } from 'redux/modules/userNotes/Actions'
import { TUserNote } from 'redux/modules/userNotes/TReducer'

const { post } = RequestMethods()

export interface ISagaWorker_CreateUserNote {
  userId: number
  text: string
}

export default function* SagaWorker_CreateUserNote(action: PayloadAction<ISagaWorker_CreateUserNote>) {
  try {
    yield put(Actions_UserNotes.store.showLoader())

    const { userId, text } = action.payload

    const data: TCreateNotePayload = {
      type: 'user',
      entityId: userId,
      text,
    }

    yield call(async () => await post<TUserNote>(`/notes`, data))

    yield call(SagaWorker_GetUserNotes, action)

    yield put(Actions_Notifications.store.setNotification({ message: 'Note successfully added', type: 'Success' }))
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  } finally {
    yield put(Actions_UserNotes.store.hideLoader())
  }
}
